import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/components/sections/HeroSection';
import WhatIsSection from '@/components/sections/WhatIsSection';
import BenefitsSection from '@/components/sections/BenefitsSection';
import CategoriesSection from '@/components/sections/CategoriesSection';
import ProductCarouselSection from '@/components/sections/ProductCarouselSection';
import HowItWorksSection from '@/components/sections/HowItWorksSection';
import ReviewSection from '@/components/sections/ReviewSection';
import ShippingSection from '@/components/sections/ShippingSection';
import SafetySection from '@/components/sections/SafetySection';
import ArticlesSection from '@/components/sections/ArticlesSection';
import FAQSection from '@/components/sections/FAQSection';
import FinalCTASection from '@/components/sections/FinalCTASection';
import { categoryProducts } from '@/mocks/products';

export default function HomeDe() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage('de');
    document.title = t('siteTitle');
  }, [i18n, t]);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <WhatIsSection />
        <BenefitsSection />
        <CategoriesSection />

        <ProductCarouselSection categoryTitle="Shoes" products={categoryProducts.shoes} />
        <ProductCarouselSection categoryTitle="Hoodies / Sweaters" products={categoryProducts.hoodies} />
        <ProductCarouselSection categoryTitle="T-Shirts" products={categoryProducts.tshirts} />
        <ProductCarouselSection categoryTitle="Jackets" products={categoryProducts.jackets} />
        <ProductCarouselSection categoryTitle="Pants / Shorts" products={categoryProducts.pants} />
        <ProductCarouselSection categoryTitle="Headwear" products={categoryProducts.headwear} />
        <ProductCarouselSection categoryTitle="Sets" products={categoryProducts.sets} />
        <ProductCarouselSection categoryTitle="Underwear / Underpants" products={categoryProducts.underwear} />
        <ProductCarouselSection categoryTitle="Jersey" products={categoryProducts.jersey} />
        <ProductCarouselSection categoryTitle="Accessories" products={categoryProducts.accessories} />
        <ProductCarouselSection categoryTitle="Bags" products={categoryProducts.bags} />
        <ProductCarouselSection categoryTitle="Belts" products={categoryProducts.belts} />
        <ProductCarouselSection categoryTitle="Perfumes" products={categoryProducts.perfumes} />
        <ProductCarouselSection categoryTitle="Other Stuff" products={categoryProducts.other} />

        <HowItWorksSection />
        <ReviewSection />
        <ShippingSection />
        <SafetySection />
        <ArticlesSection />
        <FAQSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}